var _defs, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhonepe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5f259f;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256,
    cy: 256,
    r: 240
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.93,193.37c0-9.38-8.05-17.43-17.43-17.43h-32.18l-73.74-84.47c-6.7-8.05-17.43-10.73-28.15-8.05l-25.47,8.05c-4.02,1.34-5.37,6.7-2.68,9.38l80.44,76.43h-122.02c-4.02,0-6.7,2.68-6.7,6.7v13.4c0,9.38,8.05,17.43,17.43,17.43h18.77v64.36c0,48.27,25.47,76.43,68.38,76.43,13.4,0,24.14-1.34,37.54-6.7v42.91c0,12.07,9.38,21.45,21.45,21.45h18.77c4.02,0,8.05-4.02,8.05-8.05v-191.73h30.84c4.02,0,6.7-2.68,6.7-6.7v-13.41ZM279.12,308.67c-8.05,4.02-18.77,5.37-26.82,5.37-21.45,0-32.18-10.73-32.18-34.86v-64.36h58.99v93.85Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepe);
export default __webpack_public_path__ + "static/media/phonepe.aecfa8ad874f2325e2c5e2e15100bb29.svg";
export { ForwardRef as ReactComponent };